export default __webpack_public_path__ + "static/media/3132 knife block C side.ec709bd5.png";